import { z } from 'zod';

export const idWithNameSchema = z.object({
  name: z.string(),
  id: z.number(),
});

export type IdWithNameApi = z.input<typeof idWithNameSchema>;
export type IdWithNameEntity = z.infer<typeof idWithNameSchema>;
